import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";
import {
  Alert,
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  Modal,
  DatePicker,
  TimePicker,
  InputNumber,
  Checkbox,
  message,
} from "antd";
import moment from "moment-timezone";

import classes from "./RandomizeFormSeparate.css";
import {
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { connect } from "react-redux";
import {
  getRandomizationSitesRequest,
  randomizeRequest,
} from "../../api/requests";

import { range } from "../../utils/range";
import {logout} from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class RandomizeFormSeparate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,

      dispensingSites: [],
      siteListLoading: false,
      selectedToSite: null,
      confirmPopup: false,
      siteTz: null,
    };
  }

  async componentDidMount() {
    moment.tz.setDefault(this.props.userTimezone || "UTC");

    const from_site_id = get(this.props, "site.code", null);
    if (from_site_id !== null) {
      await this.getRandomizationSitesList(from_site_id);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sites.length === 0 && this.props.sites.length === 1) {
      const code = get(this.props.sites, "[0].code");
      this.props.form.setFieldsValue({ site: code });
      this.onFromChange(code);
    }
  }

  componentWillUnmount() {
    moment.tz.setDefault();
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        if (this.state.confirmPopup) {
          const randomize = { ...values };

          if (values.stroke_onsent_date && values.stroke_onsent_time) {
            randomize.stroke_onsent = moment(
              `${values.stroke_onsent_date.format(
                "YYYY-MM-DD"
              )}T${values.stroke_onsent_time.format("HH:mm")}`
            )
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss");
          }
          if (values.baseline_ct_mri_date && values.baseline_ct_mri_time) {
            randomize.baseline_ct_mri = moment(
              `${values.baseline_ct_mri_date.format(
                "YYYY-MM-DD"
              )}T${values.baseline_ct_mri_time.format("HH:mm")}`
            )
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss");
          }

          delete randomize.stroke_onsent_date;
          delete randomize.stroke_onsent_time;
          delete randomize.baseline_ct_mri_time;
          delete randomize.baseline_ct_mri_date;
          delete randomize.is_correct;

          if (values.birthdate) {
            randomize.birthdate = `${values.birthdate}-01-01`;
          }

          try {
            const { data } = await randomizeRequest(randomize);
            this.setState({ confirmPopup: false });
            this.props.handleSubmit(data);
          } catch (e) {
            if (get(e, "response.status") === 401) {
              this.props.logout();
              return;
            }

            if (e.response) {
              const errors = e.response.data.error;
              if (errors) {
                message.config({ style: { color: "#424242" } });
                message.error(errors, 5);
              }
            }

            if (get(e, "response.data.errors")) {
              const errors = {};
              Object.keys(get(e, "response.data.errors")).forEach(
                (errorFieldKey) => {
                  errors[errorFieldKey] = {
                    value: values[errorFieldKey],
                    errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                      (errorMessage) => new Error(errorMessage)
                    ),
                  };
                }
              );
              this.props.form.setFields(errors);
            }
          }
        } else {
          this.setState({ confirmPopup: true });
        }
      }

      this.setState({ isLoading: false });
    });
  };

  getRandomizationSitesList = async (from_site_id) => {
    this.setState({
      errorMessage: null,
      siteListLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getRandomizationSitesRequest(from_site_id);
      this.setState({
        dispensingSites: data.map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
          has_own_vials: get(site, "has_own_vials"),
        })),
        siteListLoading: false,
        selectedToSite: null,
      });

      if (data.length === 1) {
        this.props.form.setFieldsValue({ storage_id: get(data, "[0].id") });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        dispensingSites: [],
        subject: null,
        errorMessage: get(e, "response.data.error", this.props.i18n.t("Error")),
      });
    }
    this.setState({ siteListLoading: false });
  };

  onFromChange = async (value) => {
    this.props.form.setFieldsValue({ storage_id: null });

    const site = find(this.props.sites, ({ code }) => code === value);
    this.setState({ siteTz: site.time_zone });
    moment.tz.setDefault(this.props.userTimezone || site.time_zone || "UTC");

    try {
      await this.getRandomizationSitesList(value);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
      console.log(e);
    }
  };

  getNow = () => {
    return moment();
  };

  render() {
    const {
      getFieldDecorator,
      getFieldValue,
      getFieldsError,
    } = this.props.form;
    const { isEditableRandomize, sites } = this.props;
    const { dispensingSites, confirmPopup, isLoading, siteTz } = this.state;

    const site = find(sites, ({ code }) => code === getFieldValue("site"));

    const storage = find(
      dispensingSites,
      ({ value }) => value === getFieldValue("storage_id")
    );

    const isEditable =
      isEditableRandomize &&
      get(site, "state") === "active" &&
      get(site, "randomization_permitted");

    return (
      <Row className={classes.wrapper}>
        <Col md={24} lg={18}>
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={12}>
              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('Site*')}</b>
                  <Form.Item>
                    {getFieldDecorator("site", {
                      rules: [
                        {
                          required: true,
                          message: this.props.i18n.t('Please input site id'),
                        },
                      ],
                    })(
                      <Select
                        placeholder={this.props.i18n.t('Select site')}
                        onChange={this.onFromChange}
                      >
                        {sites.map(({ code, name }) => (
                          <Option value={code} key={code}>
                            {name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              {getFieldValue("site") &&
                (() => {
                  if (get(site, "state") !== "active") {
                    return (
                      <Col md={24}>
                        <Alert type="error" message={this.props.i18n.t('NamespaceRandomizeFormSeparate:Site is inactive')} />
                        <br />
                      </Col>
                    );
                  }
                })()}

              {getFieldValue("site") &&
                (() => {
                  if (!get(site, "randomization_permitted")) {
                    return (
                      <Col md={24}>
                        <Alert
                          type="error"
                          message={this.props.i18n.t('NamespaceRandomizeFormSeparate:Site is not permitted for Randomization.')}
                        />
                        <br />
                      </Col>
                    );
                  }
                })()}

              <Col span={24}>
                <label>
                  <b>{this.props.i18n.t('Active Fridge*')}</b>
                  <Form.Item>
                    {getFieldDecorator("storage_id", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "drug_location.id", null),
                    })(
                      <Select
                        disabled={!isEditable || this.props.siteListLoading}
                        placeholder={this.props.i18n.t('Select')}
                      >
                        {map(dispensingSites, ({ value, label }) => (
                          <Option key={value} value={value}>
                            {label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              {getFieldValue("storage_id") &&
                (() => {
                  if (!get(storage, "has_own_vials")) {
                    return (
                      <Col md={24}>
                        <Alert
                          type="error"
                          message={this.props.i18n.t('NamespaceRandomizeFormSeparate:Inadequate number of drug packages available in dispensing location. Please request more drugs!')}
                        />
                        <br />
                      </Col>
                    );
                  }
                })()}

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('Birth year*')}</b>
                  <Form.Item>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "4px",
                      }}
                    >
                      {getFieldDecorator("birthdate", {
                        rules: [
                          {
                            required: true,
                            message: this.props.i18n.t("Required"),
                          },
                        ],
                      })(
                        <InputNumber
                          disabled={!isEditable}
                          min={1900}
                          max={new Date().getFullYear()}
                          style={{ width: "100%" }}
                          onChange={(value) => {
                            const patientAge = moment().diff(
                              moment(value, "YYYY"),
                              "years"
                            );
                            this.props.form.setFieldsValue({
                              age: Number.isInteger(patientAge)
                                ? patientAge
                                : null,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Form.Item>
                </label>
              </Col>

              {(getFieldValue("age") || getFieldValue("age") === 0) && (
                <Col md={24} style={{ paddingBottom: "20px" }}>
                  {getFieldValue("age") === 18 && (
                    <Alert
                      type="warning"
                      message={this.props.i18n.t('NamespaceRandomizeFormSeparate:Please confirm this patient is truly 18 years old as of today')}
                    />
                  )}
                  {getFieldValue("age") < 18 && (
                    <Alert
                      type="error"
                      message={this.props.i18n.t('NamespaceRandomizeFormSeparate:Randomization is not allowed for patients under 18')}
                    />
                  )}
                  {getFieldValue("age") > 100 && (
                    <Alert type="error" message={this.props.i18n.t('NamespaceRandomizeFormSeparate:Birth year looks wrong')} />
                  )}
                </Col>
              )}

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('Age*')}</b>
                  <Form.Item>
                    <div>
                      {getFieldDecorator("age", {
                        rules: [
                          {
                            required: true,
                            message: this.props.i18n.t("Required"),
                          },
                        ],
                      })(<Input disabled />)}
                    </div>
                  </Form.Item>
                </label>
              </Col>
            </Row>

            <Row gutter={12}>
              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('Sex*')}</b>
                  <Form.Item>
                    {getFieldDecorator("sex", {
                      rules: [
                        {
                          required: true,
                          message: this.props.i18n.t('NamespaceRandomizeFormSeparate:Please input userID'),
                        },
                      ],
                    })(
                      <Select disabled={!isEditable}>
                        <Option value={0}>{this.props.i18n.t('Female')}</Option>
                        <Option value={1}>{this.props.i18n.t('Male')}</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Baseline Occlusion Location*')}</b>
                  <Form.Item>
                    {getFieldDecorator("baseline_occlusion_location", {
                      rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                    })(
                      <Select disabled={!isEditable}>
                        <Option value={1}>ICA</Option>
                        <Option value={2}>M1</Option>
                        <Option value={3}>M2</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('Baseline NIHSS*')}</b>
                  <Form.Item>
                    <div>
                      {getFieldDecorator("baseline_nihss", {
                        rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                      })(
                        <InputNumber
                          placeholder={`${
                            getFieldValue("baseline_occlusion_location") === 3
                              ? 11
                              : 6
                          } - 42`}
                          disabled={!isEditable}
                        />
                      )}
                    </div>
                  </Form.Item>
                </label>
              </Col>

              {getFieldValue("baseline_occlusion_location") === 3 &&
                (getFieldValue("baseline_nihss") < 11 ||
                  getFieldValue("baseline_nihss") > 42) && (
                  <Col md={24} style={{ paddingBottom: "20px" }}>
                    <Alert
                      type="error"
                      message={this.props.i18n.t('NamespaceRandomizeFormSeparate:For M2 Occlusions, NIHSS score must be between 11-42')}
                    />
                  </Col>
                )}

              {getFieldValue("baseline_occlusion_location") !== 3 &&
                (getFieldValue("baseline_nihss") < 6 ||
                  getFieldValue("baseline_nihss") > 42) && (
                  <Col md={24} style={{ paddingBottom: "20px" }}>
                    <Alert
                      type="error"
                      message={this.props.i18n.t('NamespaceRandomizeFormSeparate:NIHSS score must be between 6-42')}
                    />
                  </Col>
                )}

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('ASPECTS*')}</b>
                  <Form.Item>
                    {getFieldDecorator("aspects_score", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(
                      <Select disabled={!isEditable}>
                        <Option value={0}>5-7</Option>
                        <Option value={1}>8-10</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('Weight*')}</b>
                  <Form.Item>
                    {getFieldDecorator("subject_weight", {
                      rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                    })(
                      <InputNumber
                        disabled={!isEditable}
                        min={1}
                        onChange={(value) => {
                          if (getFieldValue("subject_weight_unit")) {
                            let subjectDose =
                              value *
                              0.13 *
                              (getFieldValue("subject_weight_unit") === "kgs"
                                ? 1
                                : 0.4535);
                            if (subjectDose > 13.5) {
                              subjectDose = 13.5;
                            }

                            this.props.form.setFieldsValue({
                              subject_dose: subjectDose.toFixed(1),
                            });
                          }
                        }}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Randomization Weight Unit*')}</b>
                  <Form.Item>
                    {getFieldDecorator("subject_weight_unit", {
                      rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                    })(
                      <Select
                        disabled={!isEditable}
                        onChange={(value) => {
                          if (getFieldValue("subject_weight")) {
                            let subjectDose =
                              getFieldValue("subject_weight") *
                              0.13 *
                              (value === "kgs" ? 1 : 0.4535);
                            if (subjectDose > 13.5) {
                              subjectDose = 13.5;
                            }
                            this.props.form.setFieldsValue({
                              subject_dose: subjectDose.toFixed(1),
                            });
                          }
                        }}
                      >
                        <Option value="kgs">{this.props.i18n.t("Kgs")}</Option>
                        <Option value="lbs">{this.props.i18n.t("Lbs")}</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
              {getFieldValue("subject_weight") &&
                getFieldValue("subject_weight_unit") && (
                  <div>
                    {(getFieldValue("subject_weight_unit") === "kgs"
                      ? 1
                      : 0.4535) *
                      getFieldValue("subject_weight") >
                      120 && (
                      <Col md={24}>
                        <Alert
                          type="error"
                          message={`${this.props.i18n.t('NamespaceRandomizeFormSeparate:Maximum weight is')} ${
                            getFieldValue("subject_weight_unit") === "kgs"
                              ? "120kg"
                              : "264.6lbs"
                          }`}
                        />
                        <br />
                      </Col>
                    )}
                    {(getFieldValue("subject_weight_unit") === "kgs"
                      ? 1
                      : 0.4535) *
                      getFieldValue("subject_weight") <
                      40 && (
                      <Col md={24}>
                        <Alert
                          type="error"
                          message={`${this.props.i18n.t('NamespaceRandomizeFormSeparate:Are you sure the weight is')} <= ${
                            getFieldValue("subject_weight_unit") === "kgs"
                              ? "40kg"
                              : "88.2lbs"
                          }`}
                        />
                        <br />
                      </Col>
                    )}
                  </div>
                )}

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:How was this weight at randomization determined?*')}</b>
                  <Form.Item>
                    {getFieldDecorator("subject_weight_determined", {
                      rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                    })(
                      <Select disabled={!isEditable}>
                        <Option value="actual">{this.props.i18n.t('Actual')}</Option>
                        <Option value="estimated">{this.props.i18n.t('Estimated')}</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              {/*<Col md={3}>
                        <label>
                          <b>IND Consent</b>
                          <Form.Item>
                            {getFieldDecorator('ind_consent', {
                              rules: [{ required: false, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                              initialValue: get(this.props, 'profile.ind_consent', null)
                            })(
                              <Select>
                                <Option value={null}>{this.props.i18n.t("None")}</Option>
                                <Option value='Yes'>{this.props.i18n.t("Yes")}</Option>
                                <Option value='No'>{this.props.i18n.t("No")}</Option>
                              </Select>,
                            )}
                          </Form.Item>
                        </label>
                      </Col>*/}

              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t('Dose ml')}</b>
                  <Form.Item>
                    {getFieldDecorator("subject_dose", {})(<Input disabled />)}
                  </Form.Item>
                </label>
              </Col>
              <Col md={24}>
                <label>
                  <b>
                    {this.props.i18n.t('NamespaceRandomizeFormSeparate:Stroke onset date* (please enter local time - 24hr format)')}
                  </b>
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "4px",
                  }}
                >
                  <Form.Item>
                    <div style={{ width: "120px" }}>
                      {getFieldDecorator("stroke_onsent_date", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                        initialValue: null,
                      })(
                        <DatePicker
                          disabled={!isEditable}
                          format="YYYY/MM/DD"
                          placeholder="yyyy-mm-dd"
                          disabledDate={(currentDate) => {
                            const now = this.getNow();
                            const currentTimeHour = now.hour();
                            return (
                              moment(currentDate.format("YYYY-MM-DD")) >
                                moment(now.format("YYYY-MM-DD")) ||
                              moment(currentDate.format("YYYY-MM-DD")) <
                                moment(now.format("YYYY-MM-DD")).subtract(
                                  currentTimeHour > 12 ? 0 : 1,
                                  "days"
                                )
                            );
                          }}
                          showToday={false}
                        />
                      )}
                    </div>
                  </Form.Item>
                  &nbsp;&nbsp;
                  <Form.Item>
                    <div style={{ width: "120px" }}>
                      {getFieldDecorator("stroke_onsent_time", {
                        rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                        initialValue: null,
                      })(
                        <TimePicker
                          disabled={
                            !isEditable || !getFieldValue("stroke_onsent_date")
                          }
                          format="HH:mm"
                          placeholder="HH:mm"
                          disabledHours={() => {
                            const now = this.getNow();

                            const currentTimeDate = now.date();
                            const strokeDate = moment(
                              getFieldValue("stroke_onsent_date")
                            ).date();
                            const currentTimeHour = now.hour();

                            if (currentTimeDate === strokeDate) {
                              return [
                                ...range(0, currentTimeHour - 12),
                                ...range(currentTimeHour + 1, 25),
                              ];
                            } else {
                              return range(0, currentTimeHour + 12);
                            }
                          }}
                          disabledMinutes={() => {
                            const now = this.getNow();
                            const strokeDate = getFieldValue(
                              "stroke_onsent_date"
                            );
                            const strokeTime = getFieldValue(
                              "stroke_onsent_time"
                            );

                            if (
                              strokeTime &&
                              now.date() === strokeDate.date() &&
                              strokeTime.hour() === now.hour()
                            ) {
                              return range(now.minute() + 1, 60);
                            }
                            if (
                              strokeTime &&
                              strokeTime.hour() ===
                                now.subtract(12, "hours").hour()
                            ) {
                              return range(0, now.minute());
                            }

                            if (!strokeTime) {
                              return range(0, 60);
                            }
                          }}
                          showToday={false}
                        />
                      )}
                    </div>
                  </Form.Item>
                  &nbsp;&nbsp;&nbsp;
                  <Form.Item>
                    {this.props.userShortTimezone || siteTz || "UTC"}
                  </Form.Item>
                </div>
              </Col>

              {((getFieldValue("stroke_onsent_date") &&
                getFieldValue("stroke_onsent_time")) ||
                get(this.props, "profile.stroke_onsent")) && (
                <Col md={24}>
                  <div style={{ padding: "0 0 30px" }}>
                    <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Onset to randomization time (minutes)')}:</b>&nbsp;
                    {(() => {
                      const now = this.getNow();
                      let strokeDate;

                      if (
                        getFieldValue("stroke_onsent_date") &&
                        getFieldValue("stroke_onsent_time")
                      ) {
                        strokeDate = moment(
                          `${getFieldValue("stroke_onsent_date").format(
                            "YYYY-MM-DD"
                          )} ${getFieldValue("stroke_onsent_time").format(
                            "HH:mm"
                          )}`
                        );
                      } else if (get(this.props, "profile.stroke_onsent")) {
                        strokeDate = moment
                          .utc(get(this.props, "profile.stroke_onsent"))
                          .tz(this.props.userTimezone || siteTz || "UTC");
                      }

                      return now.diff(strokeDate, "minutes");
                    })()}
                  </div>
                </Col>
              )}

              <Col md={24}>
                <label>
                  <b>
                    {this.props.i18n.t('NamespaceRandomizeFormSeparate:Baseline CT/MRI Date* (please enter local time - 24hr format)')}
                  </b>
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "4px",
                  }}
                >
                  <Form.Item>
                    <div style={{ width: "120px" }}>
                      {getFieldDecorator("baseline_ct_mri_date", {
                        rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                        initialValue: null,
                      })(
                        <DatePicker
                          disabled={!isEditable}
                          format="YYYY/MM/DD"
                          placeholder="yyyy-mm-dd"
                          disabledDate={(currentDate) => {
                            const now = this.getNow();
                            const currentTimeHour = now.hour();
                            return (
                              moment(currentDate.format("YYYY-MM-DD")) >
                                moment(now.format("YYYY-MM-DD")) ||
                              moment(currentDate.format("YYYY-MM-DD")) <
                                moment(now.format("YYYY-MM-DD")).subtract(
                                  currentTimeHour > 12 ? 0 : 1,
                                  "days"
                                )
                            );
                          }}
                          showToday={false}
                        />
                      )}
                    </div>
                  </Form.Item>
                  &nbsp;&nbsp;
                  <Form.Item>
                    <div style={{ width: "120px" }}>
                      {getFieldDecorator("baseline_ct_mri_time", {
                        rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                        initialValue: null,
                      })(
                        <TimePicker
                          disabled={
                            !isEditable ||
                            !getFieldValue("baseline_ct_mri_date")
                          }
                          format="HH:mm"
                          placeholder="HH:mm"
                          disabledHours={() => {
                            const now = this.getNow();

                            const currentTimeDate = now.date();
                            const strokeDate = moment(
                              getFieldValue("baseline_ct_mri_date")
                            ).date();
                            const currentTimeHour = now.hour();

                            if (currentTimeDate === strokeDate) {
                              return [
                                ...range(0, currentTimeHour - 12),
                                ...range(currentTimeHour + 1, 25),
                              ];
                            } else {
                              return range(0, currentTimeHour + 12);
                            }
                          }}
                          disabledMinutes={() => {
                            const now = this.getNow();
                            const baselineDate = getFieldValue(
                              "baseline_ct_mri_date"
                            );
                            const baselineTime = getFieldValue(
                              "baseline_ct_mri_time"
                            );

                            if (
                              baselineTime &&
                              now.date() === baselineDate.date() &&
                              baselineTime.hour() === now.hour()
                            ) {
                              return range(now.minute() + 1, 60);
                            }
                            if (
                              baselineTime &&
                              baselineTime.hour() ===
                                now.subtract(12, "hours").hour()
                            ) {
                              return range(0, now.minute());
                            }

                            if (!baselineTime) {
                              return range(0, 60);
                            }
                          }}
                          showToday={false}
                        />
                      )}
                    </div>
                  </Form.Item>
                  &nbsp;&nbsp;&nbsp;
                  <Form.Item>
                    {this.props.userShortTimezone || siteTz || "UTC"}
                  </Form.Item>
                </div>
              </Col>

              {((getFieldValue("baseline_ct_mri_date") &&
                getFieldValue("baseline_ct_mri_time")) ||
                get(this.props, "profile.baseline_ct_mri")) && (
                <Col md={24}>
                  <div style={{ padding: "0 0 30px" }}>
                    <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Baseline CT/MRI to randomization time (minutes)')}:</b>&nbsp;
                    {(() => {
                      const now = this.getNow();
                      let strokeDate;

                      if (
                        getFieldValue("baseline_ct_mri_date") &&
                        getFieldValue("baseline_ct_mri_time")
                      ) {
                        strokeDate = moment(
                          `${getFieldValue("baseline_ct_mri_date").format(
                            "YYYY-MM-DD"
                          )} ${getFieldValue("baseline_ct_mri_time").format(
                            "HH:mm"
                          )}`
                        );
                      } else if (get(this.props, "profile.baseline_ct_mri")) {
                        strokeDate = moment
                          .utc(get(this.props, "profile.baseline_ct_mri"))
                          .tz(this.props.userTimezone || siteTz || "UTC");
                      }

                      return now.diff(strokeDate, "minutes");
                    })()}
                  </div>
                </Col>
              )}

              {(() => {
                if (
                  getFieldValue("baseline_ct_mri_time") &&
                  getFieldValue("baseline_ct_mri_date") &&
                  getFieldValue("stroke_onsent_date") &&
                  getFieldValue("stroke_onsent_time")
                ) {
                  const stroke = moment(
                    `${getFieldValue("stroke_onsent_date").format(
                      "YYYY-MM-DD"
                    )} ${getFieldValue("stroke_onsent_time").format("HH:mm")}`
                  );
                  const baseline = moment(
                    `${getFieldValue("baseline_ct_mri_date").format(
                      "YYYY-MM-DD"
                    )} ${getFieldValue("baseline_ct_mri_time").format("HH:mm")}`
                  );

                  if (stroke.isAfter(baseline)) {
                    return (
                      <Col md={24}>
                        <div
                          style={{ marginBottom: "24px", marginTop: "-18px" }}
                        >
                          <Alert
                            type="warning"
                            message={this.props.i18n.t('NamespaceRandomizeFormSeparate:Are you sure the Baseline CT/MRI Date is prior to the Stroke onset date?')}
                          />
                        </div>
                      </Col>
                    );
                  }
                }
              })()}
            </Row>

            <Row gutter={12}>
              <Col md={24}>
                <label>
                  {this.props.i18n.t('NamespaceRandomizeFormSeparate:Please CONFIRM that the subject meets eligibility criteria, has the consent process been completed according to local requirements and is ready to be randomized!')}
                </label>
                <Form.Item>
                  {getFieldDecorator("confirm", {
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t(this.props.i18n.t("Required")),
                      },
                    ],
                  })(
                    <Select disabled={!isEditable}>
                      <Option value="yes">{this.props.i18n.t('Yes')}</Option>
                      <Option value="">{this.props.i18n.t('No')}</Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>

              <Col md={24}>
                <Form.Item>
                  <Button
                    disabled={
                      !isEditable ||
                      (getFieldValue("subject_weight") &&
                        getFieldValue("subject_weight_unit") &&
                        (getFieldValue("subject_weight_unit") === "kgs"
                          ? 1
                          : 0.4535) *
                          getFieldValue("subject_weight") >
                          120) ||
                      getFieldValue("age") < 18 ||
                      !get(storage, "has_own_vials") ||
                      (getFieldValue("baseline_occlusion_location") === 3 &&
                        (getFieldValue("baseline_nihss") < 11 ||
                          getFieldValue("baseline_nihss") > 42)) ||
                      (getFieldValue("baseline_occlusion_location") !== 3 &&
                        (getFieldValue("baseline_nihss") < 6 ||
                          getFieldValue("baseline_nihss") > 42)) ||
                      !getFieldValue("confirm")
                    }
                    type="primary"
                    htmlType="submit"
                  >
                    {this.props.i18n.t('Randomize')}
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            <Modal
              visible={!!confirmPopup}
              onCancel={() => {
                this.setState({ confirmPopup: false });
              }}
              footer={null}
            >
              {confirmPopup && (
                <div className={classes.wrapper}>
                  <h3>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Confirm all data is correct')}</h3>

                  <div className={classes.results}>
                    <div>
                      <b>{this.props.i18n.t('Site')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {get(
                          sites.find(
                            (site) => site.code === getFieldValue("site")
                          ),
                          "name"
                        )}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Active Fridge')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {get(
                          dispensingSites.find(
                            (site) => site.value === getFieldValue("storage_id")
                          ),
                          "label"
                        )}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Birth year')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("birthdate")}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Sex')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("sex") === 1 ? "Male" : "Female"}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Baseline NIHSS')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("baseline_nihss")}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Baseline Occlusion Location')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("baseline_occlusion_location") === 1 &&
                          "ICA"}
                        {getFieldValue("baseline_occlusion_location") === 2 &&
                          "M1"}
                        {getFieldValue("baseline_occlusion_location") === 3 &&
                          "M2"}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:ASPECTS')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("aspects_score") === 0 && "5-7"}
                        {getFieldValue("aspects_score") === 1 && "8-10"}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Weight')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("subject_weight")}{" "}
                        {getFieldValue("subject_weight_unit")}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:How was this weight at randomization determined?')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("subject_weight_determined")}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Dose')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("subject_dose")} ml
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Stroke onset date')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("stroke_onsent_date").format(
                          "YYYY-MM-DD"
                        )}{" "}
                        {getFieldValue("stroke_onsent_time").format("HH:mm")}{" "}
                        {this.props.userShortTimezone || siteTz || "UTC"}
                      </div>
                    </div>
                    <div>
                      <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:Baseline CT/MRI Date')}</b>
                      <div style={{ paddingBottom: "8px" }}>
                        {getFieldValue("baseline_ct_mri_date").format(
                          "YYYY-MM-DD"
                        )}{" "}
                        {getFieldValue("baseline_ct_mri_time").format("HH:mm")}{" "}
                        {this.props.userShortTimezone || siteTz || "UTC"}
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr />
                  <br />

                  <label>
                    <b>{this.props.i18n.t('NamespaceRandomizeFormSeparate:I verified the randomization above and I confirm that all all the data is correct.')}</b>
                  </label>
                  <Form.Item>
                    {getFieldDecorator("is_correct", {
                      rules: [{ required: true, message: this.props.i18n.t(this.props.i18n.t("Required")) }],
                    })(
                      <Select
                        disabled={!isEditable}
                        style={{ width: "280px", height: "32px" }}
                      >
                        <Option value="">{this.props.i18n.t('No')}</Option>
                        <Option value="yes">{this.props.i18n.t('Yes')}</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <label>
                    <b>{this.props.i18n.t('Password*')}</b>
                    <Form.Item>
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                          },
                        ],
                      })(<Input.Password />)}
                    </Form.Item>
                  </label>

                  <Row>
                    <Col>
                      {Object.keys(getFieldsError())
                        .filter((item) => getFieldsError()[item])
                        .map((errorKey, i) => {
                          if (
                            Object.prototype.toString.call(
                              getFieldsError()[errorKey]
                            ) === "[object String]"
                          ) {
                            return (
                              <Alert
                                key={i}
                                type="error"
                                message={`${errorKey}: ${
                                  getFieldsError()[errorKey]
                                }`}
                                style={{ marginBottom: "4px" }}
                              />
                            );
                          }

                          if (
                            Object.prototype.toString.call(
                              getFieldsError()[errorKey]
                            ) === "[object Array]"
                          ) {
                            return getFieldsError()[
                              errorKey
                            ].map((error, j) => (
                              <Alert
                                key={`${i}-${j}`}
                                type="error"
                                message={`${errorKey}: ${error}`}
                                style={{ marginBottom: "4px" }}
                              />
                            ));
                          }
                        })}
                    </Col>
                  </Row>

                  <Row>
                    <Col md={18}>
                      <Form.Item>
                        <Button
                          disabled={
                            hasErrors(getFieldsError()) ||
                            !getFieldValue("is_correct")
                          }
                          onClick={this.handleSubmit}
                          loading={isLoading}
                          type="primary"
                          htmlType="submit"
                        >
                          {isLoading
                            ? this.props.i18n.t('NamespaceRandomizeFormSeparate:Randomization in progress. Please wait ...')
                            : this.props.i18n.t('NamespaceRandomizeFormSeparate:Confirm randomization')}
                        </Button>
                      </Form.Item>
                    </Col>

                    <Col md={6}>
                      <Form.Item>
                        <Button
                          onClick={() => {
                            this.setState({ confirmPopup: false });
                          }}
                        >
                          {this.props.i18n.t('Back')}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}
            </Modal>
          </Form>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

const mapDispatchToProps = { logout };

export default Form.create()(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(RandomizeFormSeparate)));



// WEBPACK FOOTER //
// ./src/components/RandomizeFormSeparate/RandomizeFormSeparate.js